import * as actions from '../../actions/actionTypes';

const initialState = -1;

export default function apikeyId(state = initialState, action) {
  switch (action.type) {
    case actions.INIT_CURRENT_USER:
      return initialState;
    case actions.SET_CURRENT_USER:
      if (action.body && typeof action.body.apikeyId !== 'undefined') {
        return action.body.apikeyId;
      } else {
        return state;
      }
    default:
      return state;
  }
}
